import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export enum IconSizesEnum {
  x_small = 'x-small',
  small = 'small',
  medium = 'medium',
  large = 'large',
  x_large = 'x_large',
  huge = 'huge',
  custom = 'custom',
}

export interface IIcon {
  name: string;
  size: IconSizesEnum;
  customClass?: string;
}

@Component({
  selector: 'i2g-icon',
  templateUrl: 'icon.component.html',
  styleUrls: ['icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnInit {
  @Input() icon: IIcon;
  @Input() name: string;
  @Input() size: string;
  @Input() customClass: string;

  locationPath$: Observable<string>;

  constructor(private _router: Router) {}

  ngOnInit() {
    this.locationPath$ = this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects)
    );
  }
}
